import React, { useMemo } from "react";
import { View, StyleSheet, TextInput } from "react-native";
import NtTouchableEffect from "./NtTouchableEffect";
import NtMaterialIcon from "./NtMaterialIcon";
import NtText from "./NtText";
import { useTheme } from "../context/ThemeContext";

function NtSearchBar({
  containerStyle,
  filterCount = 0,
  onFilterPress,
  ...otherProps
}) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  const renderDelete = () => {
    if (!otherProps?.value) return null;
    return (
      <NtTouchableEffect
        style={styles.iconBtn}
        onPress={() => otherProps.onChangeText?.("")}
      >
        <NtMaterialIcon name="close" color={theme.textDim} size={16} />
      </NtTouchableEffect>
    );
  };

  const renderFilter = () => {
    if (!onFilterPress) return null;
    const filterEnabled = filterCount > 0;
    return (
      <NtTouchableEffect style={styles.iconBtn} onPress={onFilterPress}>
        <NtMaterialIcon
          name="filter"
          size={18}
          color={filterEnabled ? theme.brand2 : theme.textDim}
        />
        {filterEnabled ? (
          <NtText style={[styles.filterCount, { color: theme.brand2 }]}>
            {filterCount}
          </NtText>
        ) : null}
      </NtTouchableEffect>
    );
  };

  return (
    <View style={[styles.container, containerStyle]}>
      <NtMaterialIcon name="magnify" color={theme.textDim} size={16} />
      <TextInput
        style={styles.input}
        placeholder="Search"
        placeholderTextColor={theme.textMute}
        {...otherProps}
      />
      {renderDelete()}
      {renderFilter()}
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: {
      flexDirection: "row",
      alignItems: "center",
      backgroundColor: t.surface2,
      borderWidth: 1,
      borderColor: t.borderSoft,
      paddingHorizontal: 10,
      paddingVertical: 6,
      borderRadius: t.radius,
      gap: 6,
    },
    input: {
      flex: 1,
      fontSize: 13,
      color: t.text,
      paddingVertical: 0,
      marginHorizontal: 4,
      outlineStyle: "none",
    },
    iconBtn: {
      flexDirection: "row",
      alignItems: "center",
      paddingHorizontal: 4,
      paddingVertical: 2,
    },
    filterCount: {
      fontSize: 11,
      fontWeight: "700",
      marginLeft: 3,
    },
  });

export default NtSearchBar;
